module.exports = __webpack_public_path__ + "img/bug-report.c04cd1bd.png";